<template>
  <div class="maintain-times-level-modal">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      @open="handleOpen"
      @closed="handleClosed"
      width="45%"
    >
      <div class="dialog-inner">
        <div class="level-row">
          <div class="level-order">第一级</div>
          <div class="level-config">
            {{name}}
            小于
            <el-input-number v-model="data.firstLevel1" :controls="false" :min="1" :max="999" @change="(val) => handleFirstLevel1Change(val)"></el-input-number>
            {{unit}}
          </div>
        </div>
        <div class="level-row">
          <div class="level-order">第二级</div>
          <div class="level-config">
            {{name}}
            为
            <el-input-number v-model="data.secondLevel1" disabled :controls="false" :min="data.firstLevel1" :max="999"></el-input-number>
            -
            <el-input-number v-model="data.secondLevel2" :controls="false" :min="data.secondLevel1 + 1" :max="999" @change="(val) => handleSecondLevel2Change(val)"></el-input-number>
            {{unit}}
          </div>
        </div>
        <div class="level-row">
          <div class="level-order">第三级</div>
          <div class="level-config">
            {{name}}
            大于
            <el-input-number v-model="data.thirdLevel1" disabled :controls="false" :min="data.secondLevel2" :max="999"></el-input-number>
            {{unit}}
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="handleConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    unit: {
      type: String,
      default: '',
    },
    defaultData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      // orders: ['一', '二', '三', '四', '五'],
      data: [],
      dialogVisible: false,
      submitLoading: false,
    }
  },
  methods: {
    handleOpen() {
      this.data = JSON.parse(JSON.stringify(this.defaultData))
    },
    handleClosed() {
      this.submitLoading = false
      this.data = {
        firstLevel1: 0,
        firstLevel2: 0,
        secondLevel1: 0,
        secondLevel2: 0,
        thirdLevel1: 0,
      }
    },
    handleCancel() {
      this.dialogVisible = false
    },
    handleConfirm() {
      if (this.submitLoading) return
      if (Object.values(this.data).some((item) => !item)) {
        this.$message.error('请将维修次数分级配置完整')
        return
      }

      this.submitLoading = true
      this.$emit('change', this.data)
      this.dialogVisible = false
    },
    handleFirstLevel1Change(val) {
      this.data.secondLevel1 = val
      this.data.secondLevel2 = undefined
      this.data.thirdLevel1 = undefined
    },
    handleSecondLevel2Change(val) {
      this.data.thirdLevel1 = val
    },
  },
}
</script>

<style lang="scss" scoped>
.dialog-inner {
  padding: 8px 8px 0 8px;
  ::v-deep .el-form-item {
    margin-bottom: 0;
  }
  .level-row {
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 24px;
    font-size: 14px;
    font-weight: normal;
    line-height: 22px;
    color: #303133;
    .level-order {
      flex: none;
      margin-right: 16px;
    }
    .level-config {

    }
  }
}
</style>
